module.exports = __webpack_public_path__ + "img/dd2.bb207db4.png";